import React, { useEffect, useMemo, useState } from "react";
import axiosInstance from "src/api/Api";
import { useMutation } from "@tanstack/react-query";

import {
  FiX,
  FiMoreVertical,
  FiTrash2,
} from "react-icons/fi";

import {
  RiBankFill,
  RiBankCardFill,
  RiHome4Fill,
  RiLineChartFill,
  RiPieChartFill,
} from "react-icons/ri";



/* =======================================================
   API
======================================================= */

const fetchNotifications = async () => {
  const { data } = await axiosInstance.get(
    "/notification/all"
  );

  return data;
};

const markAsRead = async (id) => {
  const { data } = await axiosInstance.patch(
    `/notification/read/${id}`
  );

  return data;
};

const deleteNotification = async (id) => {
  const { data } = await axiosInstance.delete(
    `/notification/delete/${id}`
  );

  return data;
};

const deleteAllNotifications = async () => {
  const { data } = await axiosInstance.delete(
    "/notification/delete"
  );

  return data;
};

/* =======================================================
   TODO API
======================================================= */

const fetchTodos = async () => ({
  data: [
    {
      id: 1,
      title: "Approve new payment: CHF 1'800",
      subtitle: "Payments",
      is_done: 0,
    },
    {
      id: 2,
      title: "Your Swisscom eBill has arrived",
      subtitle: "eBill",
      is_done: 0,
    },
    {
      id: 3,
      title: "You received a new card invoice",
      subtitle: "Cards",
      is_done: 0,
    },
    {
      id: 4,
      title: "Client action required",
      subtitle: "Accounts",
      is_done: 0,
    },
  ],
});

/* =======================================================
   CATEGORY FILTERS
======================================================= */

const FILTERS = [
  "All",
  "Accounts",
];



/* =======================================================
   ICONS
======================================================= */

const notificationIcons = {
  bank: RiBankFill,
  card: RiBankCardFill,
  chart: RiPieChartFill,
  house: RiHome4Fill,
  trade: RiLineChartFill,
};

/* =======================================================
   DATE FORMAT
======================================================= */

const formatDate = (date) => {
  const d = new Date(date);

  const today = new Date();

  if (
    d.toDateString() ===
    today.toDateString()
  ) {
    return "Today";
  }

  return d.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
  });
};

const Notifications = ({
  open,
  onClose,
  onNotificationStatusChange,
}) => {
  /* =======================================================
     STATE
  ======================================================= */

  const [tab, setTab] =
    useState("notifications");

  const [category, setCategory] =
    useState("All");

  const [notifications, setNotifications] =
    useState([]);

  const [menuOpen, setMenuOpen] =
    useState(false);
    
    const [todos, setTodos] = useState([]);

  /* =======================================================
     FETCH
  ======================================================= */

  const {
    mutate: loadNotifications,
    isPending,
  } = useMutation({
    mutationFn: fetchNotifications,

    onSuccess: (res) => {
      setNotifications(res.data || []);
    },

    onError: (err) => {
      console.log(err);
    },
  });

  /* =======================================================
     MARK READ
  ======================================================= */

  const readMutation = useMutation({
    mutationFn: markAsRead,

    onSuccess: (_, id) => {
      setNotifications((prev) =>
        prev.map((item) =>
          item.id === id
            ? {
                ...item,
                is_read: 1,
              }
            : item
        )
      );
    },
  });

  /* =======================================================
     DELETE
  ======================================================= */

  const deleteMutation = useMutation({
    mutationFn: deleteNotification,

    onSuccess: (_, id) => {
      setNotifications((prev) =>
        prev.filter(
          (item) => item.id !== id
        )
      );
    },
  });

  /* =======================================================
     DELETE ALL
  ======================================================= */

  const deleteAllMutation =
    useMutation({
      mutationFn:
        deleteAllNotifications,

      onSuccess: () => {
        setNotifications([]);
      },
    });

  /* =======================================================
     TODO MUTATION
  ======================================================= */

    const todoMutation = useMutation({
  mutationFn: fetchTodos,

  onSuccess: (res) => {
    setTodos(res.data || []);
  },

  onError: (err) => {
    console.log(err);
  },
});

  /* =======================================================
     LOAD
  ======================================================= */
useEffect(() => {
  if (open) {
    loadNotifications();
    todoMutation.mutate();
  }
}, [open]);

  /* =======================================================
     FILTERED DATA
  ======================================================= */

  const filteredNotifications =
    useMemo(() => {
      if (category === "All")
        return notifications;

      return notifications.filter(
        (item) =>
          item.category === category
      );
    }, [
      notifications,
      category,
    ]);

    useEffect(() => {
  const hasUnread = notifications.some(
    (item) => !item.is_read
  );

  onNotificationStatusChange?.(hasUnread);
}, [notifications, onNotificationStatusChange]);

  if (!open) return null;

  return (
    <div
  className="
    fixed
    top-0
    right-0
    w-[372px]
    h-screen
    bg-white
    shadow-[-12px_0_40px_rgba(0,0,0,0.18)]
    z-[9999]
    flex
    flex-col
  "
  onClick={(e) => e.stopPropagation()}
>
      {/* ==========================================
          HEADER
      ========================================== */}

      <div
        className="
          h-[64px]
          border-b
          border-[#ececec]
          px-6
          flex
          items-center
          justify-between
          shrink-0
        "
      >
        <h2
          className="
            text-[28px]
            font-medium
            text-[#222]
          "
        >
          Notifications
        </h2>

        <div className="flex items-center">

          <button
            onClick={() =>
              setMenuOpen(!menuOpen)
            }
            className="
              w-[34px]
              h-[34px]
              rounded-full
              hover:bg-[#f5f5f5]
              transition
              flex
              items-center
              justify-center
            "
          >
            <FiMoreVertical
              size={18}
              className="text-[#666]"
            />
          </button>

          <button
            onClick={onClose}
            className="
              ml-1
              w-[34px]
              h-[34px]
              rounded-full
              hover:bg-[#f5f5f5]
              transition
              flex
              items-center
              justify-center
            "
          >
            <FiX
              size={19}
              className="text-[#666]"
            />
          </button>

        </div>
      </div>

      {/* ==========================================
          TABS
      ========================================== */}

      <div
        className="
          h-[54px]
          border-b
          border-[#ececec]
          flex
          shrink-0
        "
      >
        <button
          onClick={() =>
            setTab("todo")
          }
          className={`
            relative
            flex-1
            text-[15px]
            font-medium

            ${
              tab === "todo"
                ? "text-[#222]"
                : "text-[#777]"
            }
          `}
        >
          To do

          {tab === "todo" && (
            <div
              className="
                absolute
                left-0
                bottom-0
                h-[2px]
                w-full
                bg-[#d40511]
              "
            />
          )}
        </button>

        <button
          onClick={() =>
            setTab(
              "notifications"
            )
          }
          className={`
            relative
            flex-1
            text-[15px]
            font-medium

            ${
              tab ===
              "notifications"
                ? "text-[#222]"
                : "text-[#777]"
            }
          `}
        >
          Notifications

          {tab ===
            "notifications" && (
            <div
              className="
                absolute
                left-0
                bottom-0
                h-[2px]
                w-full
                bg-[#d40511]
              "
            />
          )}
        </button>
      </div>

     {/* ==========================================
          HEADER MENU
      ========================================== */}

      {menuOpen && (
        <div
          className="
            absolute
            top-[56px]
            right-[16px]
            w-[210px]
            bg-white
            border
            border-[#dcdcdc]
            rounded-[2px]
            shadow-[0_8px_30px_rgba(0,0,0,0.12)]
            overflow-hidden
            z-[999]
          "
        >
          <button
            onClick={() => {
              setMenuOpen(false);
              deleteAllMutation.mutate();
            }}
            className="
              w-full
              h-[42px]
              px-4
              flex
              items-center
              gap-3
              text-[13px]
              text-[#222]
              hover:bg-[#f7f7f7]
              transition-colors
            "
          >
            <FiTrash2
              size={15}
              className="text-[#777]"
            />

            Delete all notifications
          </button>
        </div>
      )}

      {/* ==========================================
          CATEGORY FILTERS
      ========================================== */}

      {tab === "notifications" && (
        <div
          className="
            shrink-0
            border-b
            border-[#ececec]
            bg-white
          "
        >
          <div
            className="
              flex
              overflow-x-auto
              whitespace-nowrap
              bank-scroll
              px-4
              py-4
              gap-2
            "
          >
            {FILTERS.map((item) => (
              <button
                key={item}
                onClick={() =>
                  setCategory(item)
                }
                className={`
                  h-[30px]
                  px-4
                  rounded-full
                  border
                  text-[12px]
                  transition-all
                  duration-150
                  flex
                  items-center
                  justify-center
                  whitespace-nowrap

                  ${
                    category === item
                      ? "bg-[#2b2b2b] text-white border-[#2b2b2b]"
                      : "bg-white text-[#555] border-[#dddddd] hover:bg-[#f8f8f8]"
                  }
                `}
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* ==========================================
          CONTENT
      ========================================== */}

      <div
        className="
          flex-1
          overflow-y-auto
          overflow-x-hidden
          bank-scroll
        "
      >
                {/* ==========================================
            LOADING
        ========================================== */}

        {isPending && (
          <div className="h-full flex items-center justify-center">
            <div className="w-8 h-8 border-2 border-[#d40511] border-t-transparent rounded-full animate-spin" />
          </div>
        )}

        {/* ==========================================
            EMPTY
        ========================================== */}

        {!isPending &&
          filteredNotifications.length === 0 && (
            <div className="h-full flex items-center justify-center text-[#777] font-medium">
              <div className="text-center">
                <p className="text-[15px]">
                  No notifications
                </p>
              </div>
            </div>
          )}

        {/* ==========================================
            NOTIFICATION LIST
        ========================================== */}

        {!isPending &&
          filteredNotifications.length > 0 &&
          filteredNotifications.map((item) => {
            const Icon =
              notificationIcons[item.icon_type] ||
              RiBankFill;

            return (
              <div
                key={item.id}
                onClick={() => {
                  if (!item.is_read) {
                    readMutation.mutate(item.id);
                  }
                }}
                className="
                  group
                  relative
                  px-6
                  py-4
                  border-b
                  border-[#eeeeee]
                  hover:bg-[#fafafa]
                  transition-colors
                  cursor-pointer
                "
              >
                <div className="flex items-start">

                  {/* ================================= */}
                  {/* ICON + UNREAD DOT */}
                  {/* ================================= */}

                  <div className="relative shrink-0">

                    {!item.is_read && (
                      <span
                        className="
                          absolute
                          -left-2
                          top-[10px]
                          w-[7px]
                          h-[7px]
                          rounded-full
                          bg-[#d40511]
                        "
                      />
                    )}

                    <div
                      className="
                        w-[38px]
                        h-[38px]
                        rounded-full
                        bg-[#f6f6f6]
                        border
                        border-[#ececec]
                        flex
                        items-center
                        justify-center
                      "
                    >
                      <Icon
                        size={18}
                        className="text-[#666666]"
                      />
                    </div>

                  </div>

                  {/* ================================= */}
                  {/* CONTENT */}
                  {/* ================================= */}

                  <div className="ml-4 flex-1 pr-8">

                    <p
                      className={`
                        text-[13px]
                        leading-[20px]

                        ${
                          item.is_read
                            ? "text-[#444]"
                            : "text-[#222] font-medium"
                        }
                      `}
                    >
                      {item.title}
                    </p>

                    <div
                      className="
                        mt-[8px]
                        flex
                        items-center
                        gap-2
                        text-[11px]
                        text-[#888]
                      "
                    >
                      <span>
                        {formatDate(
                          item.notified_at
                        )}
                      </span>

                      <span>•</span>

                      <span>
                        {item.category}
                      </span>
                    </div>

                  </div>

                  {/* ================================= */}
                  {/* DELETE */}
                  {/* ================================= */}

                  <button
                    onClick={(e) => {
                      e.stopPropagation();

                      deleteMutation.mutate(
                        item.id
                      );
                    }}
                    className="
                      opacity-0
                      group-hover:opacity-100
                      transition-opacity
                      w-[28px]
                      h-[28px]
                      rounded-full
                      hover:bg-[#f1f1f1]
                      flex
                      items-center
                      justify-center
                      shrink-0
                    "
                  >
                    <FiTrash2
                      size={15}
                      className="text-[#8c8c8c]"
                    />
                  </button>

                </div>

              </div>
            );
          })}
      </div>
    

    </div>
  );
};

export default Notifications;